import { useCallback, useContext, useState } from "react";
import GlobalContext from "../../context/GlobalContext";
import DataTableComponent from "./DataTableComponent";
import defaultProfile from "../../assets/images/icon/default_profile.jpeg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { fetchAttendanceLists } from "../../api/WorkspaceApi";
import { format, parseISO } from "date-fns";
import CategoryBadge from "../utilities/CategoryBadge";
import swal from "../../services/swalConfig";
import { deleteAttendance } from "../../api/AttendanceApi";

import { tr } from "../../i18n";
const TableAttendance = () => {
  const { user, setLoading } = useContext(GlobalContext);
  const [reload, setReload] = useState(0);
  const navigate = useNavigate();

  const fetchData = useCallback(
    async ({ page, perPage, search }) => {
      if (!user?.workspace?.company_id) return { data: [], total: 0 }; // Hindari request jika company_id belum tersedia

      const response = await fetchAttendanceLists({
        companyId: user.workspace.company_id,
        page,
        perPage,
        search,
      });

      const numberedData = response.data.map((item, index) => ({
        ...item,
        no: (page - 1) * perPage + index + 1,
      }));

      return { data: numberedData, total: response.total };
    },
    [user, reload] // Tambahkan dependency agar berubah saat user berubah
  );

  const handleEdit = (id) => {
    navigate("/attendance/edit", { state: { personnel_id: id } });
  };

  const processDeleteAttendance = async (attendanceId) => {
    try {
      setLoading(true);

      const data = {
        company_id: user.workspace.company_id,
        attendance_id: attendanceId,
      };

      const response = await deleteAttendance(data);

      if (response.status == 200) {
        swal.fire({
          title: tr("shared:success"),
          text: response.message,
          icon: "success",
          showCancelButton: false,
        });

        setReload((prev) => prev + 1);
      } else {
        swal.fire({
          title: tr("common:errors.oops"),
          text: response.message,
          icon: "error",
          showCancelButton: false,
        });
      }
    } catch (error) {
      swal.fire({
        title: tr("common:errors.oops"),
        text: tr("common:errors.generic"),
        icon: "error",
        showCancelButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const result = await swal.fire({
      title: tr("shared:are_you_sure"),
      text: tr("attendance:you_want_to_delete_this_attendance"),
      icon: "warning",
      showCancelButton: false,
      confirmButtonText: tr("shared:i_understand_delete"),
      confirmButtonColor: "#f10f29ff",
      cancelButtonText: tr("common:actions.cancel"),
      timer: false,
    });

    if (result.isConfirmed) {
      processDeleteAttendance(id);
    }
  };

  const columns = [
    { name: tr("shared:no"), selector: (row) => row.no, width: "60px", sortable: true },
    {
      name: tr("attendance:date"),
      selector: (row) => format(parseISO(row.attendance_date), "dd MMM yyyy"),
      sortable: true,
      width: "130px",
    },
    {
      name: tr("shared:name"),
      selector: (row) => row.user_name,
      sortable: true,
      grow: 2,
      style: { whiteSpace: "normal", wordBreak: "break-word" },
    },
    {
      name: tr("attendance:in_time"),
      selector: (row) => row.actual_in_time || "-",
      sortable: true,
      width: "100px",
    },
    {
      name: tr("attendance:out_time"),
      selector: (row) => row.actual_out_time || "-",
      sortable: true,
      width: "100px",
    },
    {
      name: tr("attendance:category"),
      cell: (row) => (
        <CategoryBadge
          category={
            row.category === "Leave" ? row.leave_category : row.category
          }
        />
      ),
      width: "120px",
      style: {
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      },
    },
    {
      name: tr("shared:actions"),
      cell: (row) => (
        <div style={{ display: "flex", gap: "10px", whiteSpace: "nowrap" }}>
          <button
            onClick={() => handleEdit(row.attendance_id)}
            className="btn btn-primary btn-sm"
          >
            <FontAwesomeIcon icon={faEdit} className="me-1" /> {" "}{tr("common:breadcrumb.edit")}
          </button>
          <button
            onClick={() => handleDelete(row.attendance_id)}
            className="btn btn-danger btn-sm"
          >
            <FontAwesomeIcon icon={faTrash} className="me-1" /> {" "}{tr("common:actions.delete")}
          </button>
        </div>
      ),
      minWidth: "220px",
      style: {
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      },
    },
  ];

  return (
    <div>
      <DataTableComponent columns={columns} fetchData={fetchData} />
    </div>
  );
};

export default TableAttendance;
